// Anita Week 3 / Day 5 — Week Project: Mini Lab Report.
// Content is supplied verbatim by the curriculum author; this file only places
// that content into the existing Nimny Lab lesson schema. No pedagogy is invented.
// SAFETY: project review only — no new experiments, only safe Week 3 activities.

const day5 = {
  id: 'day-5',
  studentId: 'anita',
  weekId: 'week-3',
  dayId: 'day-5',
  status: 'active',
  title: 'Проект недели: мини-лабораторный отчёт / Week Project: Mini Lab Report',
  shortTitle: 'Мини-отчёт / Mini Lab Report',
  theme:
    'Анита собирает лабораторную работу недели: вопрос, предсказание, опыт, данные, вывод и безопасность. / Anita creates a weekly lab report: question, prediction, experiment, data, conclusion, and safety.',
  estimatedTimeLabel: '60–90 минут / 60–90 minutes',
  lessonTiming: { minMinutes: 60, maxMinutes: 90, breaks: 2 },
  bilingualMode: 'ru-primary-en-helper',
  courseLayers: ['reading', 'math', 'science', 'project', 'data', 'spelling', 'speech'],
  readingLevel: 'grade-2',
  nimnyIntro:
    'Нимни открывает большую лабораторную папку. Сегодня Анита соберёт всё, что делала на неделе: измерения, движение, магниты, погоду, данные и выводы. Это не экзамен — это проект маленького учёного. / Nimny opens a big lab folder. Today Anita collects what she did this week: measurement, motion, magnets, weather, data, and conclusions. This is not an exam — this is a young scientist project.',
  goals: [
    'Повторить идеи Week 3. / Review Week 3 ideas.',
    'Понять структуру лабораторного отчёта. / Understand lab report structure.',
    'Решить смешанные задачи. / Solve mixed math review.',
    'Сделать проект «Мини-лабораторный отчёт». / Create a Mini Lab Report.',
    'Объяснить вывод родителю. / Explain a conclusion to parent.',
    'Повторить правила безопасности лаборатории. / Review lab safety rules.'
  ],
  vocabulary: [
    { term: 'измерить / measure', definition: 'узнать размер. / find size.' },
    { term: 'длина / length', definition: 'насколько длинный предмет. / how long.' },
    { term: 'движение / motion', definition: 'изменение места. / change of place.' },
    { term: 'расстояние / distance', definition: 'как далеко предмет прошёл. / how far.' },
    { term: 'сила / force', definition: 'действие толкать или тянуть. / push or pull action.' },
    { term: 'магнит / magnet', definition: 'предмет, который притягивает некоторые металлы. / attracts some metals.' },
    { term: 'данные / data', definition: 'записанные наблюдения. / recorded observations.' },
    { term: 'таблица / table', definition: 'строки и столбцы. / rows and columns.' },
    { term: 'график / graph', definition: 'рисунок данных. / data picture.' },
    { term: 'вывод / conclusion', definition: 'что я поняла. / what I understood.' },
    { term: 'опыт / experiment', definition: 'безопасная проверка. / a safe test.' },
    { term: 'безопасность / safety', definition: 'правила, чтобы не было опасно. / rules to stay safe.' }
  ],
  onlineTasks: [
    {
      id: 'reading-review-words',
      type: 'text',
      title: 'Слова лаборатории / Lab Words Review',
      prompt: 'Прочитай слова недели:\nизмерить\nдлина\nдвижение\nрасстояние\nсила\nмагнит\nданные\nтаблица\nграфик\nвывод\nопыт\nбезопасность',
      ruPrimaryText: 'Прочитай 12 слов недели по-русски.',
      enHelpText: 'Read the Russian lab words first. English is only for help.',
      hint: 'Сначала прочитай сама. / Try first by yourself.',
      answer: 'Анита пробует читать русские слова. / Anita attempts the Russian reading.'
    },
    {
      id: 'oral-defense-reading',
      type: 'text',
      title: 'Фразы учёного / Scientist Phrases',
      prompt: 'Прочитай и попробуй сказать по-русски:\n1. Я задаю вопрос.\n2. Я делаю предсказание.\n3. Я провожу безопасный опыт.\n4. Я записываю данные.\n5. Я делаю вывод.',
      ruPrimaryText: 'Прочитай и произнеси вслух 5 фраз учёного.',
      enHelpText: 'I ask a question. I make a prediction. I do a safe experiment. I record data. I make a conclusion.',
      answer: 'Анита читает и пробует произнести 5 фраз. / Anita reads and attempts to say 5 phrases.'
    },
    {
      id: 'math-week3-review',
      type: 'text',
      title: 'Математическая проверка / Math Review',
      prompt:
        'Реши задачи.\n1. Книга 22 см, карандаш 14 см. На сколько книга длиннее?\n2. Машинка проехала 18 см, потом 25 см. Сколько всего?\n3. Магнит притянул 4 предмета, не притянул 6. Сколько всего?\n4. Солнечно было 3 дня, облачно 2 дня, дождь 1 день. Сколько всего дней?\n5. В отчёте 6 разделов. Анита уже сделала 4. Сколько осталось?',
      ruPrimaryText: 'Реши 5 смешанных задач по Week 3.',
      enHelpText: 'Solve 5 mixed math review questions from Week 3.',
      answer: '1) 22 − 14 = 8 см. 2) 18 + 25 = 43 см. 3) 4 + 6 = 10. 4) 3 + 2 + 1 = 6. 5) 6 − 4 = 2.'
    },
    {
      id: 'lab-safety-sort',
      type: 'classify',
      title: 'Безопасно или нет? / Safe or Not?',
      prompt:
        'Разложи 12 карточек по двум категориям:\nБезопасно с родителем\nНельзя в лаборатории Нимни\n\n1. Измерить карандаш линейкой.\n2. Сравнить книгу и ложку.\n3. Мягко толкнуть игрушечную машинку.\n4. Бросить машинку со стола.\n5. Использовать большой магнит с родителем.\n6. Взять маленький магнит в рот.\n7. Смотреть погоду из окна.\n8. Выходить одной наблюдать грозу.\n9. Записать данные в таблицу.\n10. Делать опыт с розеткой.\n11. Нарисовать график.\n12. Использовать стеклянную банку без родителя.',
      ruPrimaryText: 'Разложи 12 действий по двум категориям: безопасно с родителем или нельзя.',
      enHelpText: 'Sort 12 cards into "safe with a parent" vs "not allowed in Nimny\'s lab".',
      categories: [
        { id: 'safe-with-parent', label: 'Безопасно с родителем / Safe with a parent' },
        { id: 'not-allowed', label: 'Нельзя в лаборатории Нимни / Not allowed in Nimny\'s lab' }
      ],
      items: [
        { id: 's1-measure', label: '1. Измерить карандаш линейкой. / Measure a pencil with a ruler.' },
        { id: 's2-compare', label: '2. Сравнить книгу и ложку. / Compare a book and a spoon.' },
        { id: 's3-soft-push', label: '3. Мягко толкнуть игрушечную машинку. / Softly push a toy car.' },
        { id: 's4-throw-car', label: '4. Бросить машинку со стола. / Throw a car off the table.' },
        { id: 's5-large-magnet', label: '5. Использовать большой магнит с родителем. / Use a large magnet with a parent.' },
        { id: 's6-magnet-mouth', label: '6. Взять маленький магнит в рот. / Put a small magnet in the mouth.' },
        { id: 's7-window-weather', label: '7. Смотреть погоду из окна. / Watch weather from a window.' },
        { id: 's8-storm-alone', label: '8. Выходить одной наблюдать грозу. / Go out alone to watch a thunderstorm.' },
        { id: 's9-record-data', label: '9. Записать данные в таблицу. / Record data in a table.' },
        { id: 's10-outlet', label: '10. Делать опыт с розеткой. / Do an experiment with a wall outlet.' },
        { id: 's11-draw-graph', label: '11. Нарисовать график. / Draw a graph.' },
        { id: 's12-glass-alone', label: '12. Использовать стеклянную банку без родителя. / Use a glass jar without a parent.' }
      ],
      answer: 'Безопасно с родителем: 1, 2, 3, 5, 7, 9, 11. Нельзя: 4, 6, 8, 10, 12.'
    },
    {
      id: 'project-mini-lab-report',
      type: 'project',
      title: 'Мой мини-лабораторный отчёт / My Mini Lab Report',
      prompt:
        'Создай проект «Мини-лабораторный отчёт».\nВыбери один опыт недели:\nA. Измерить 2 предмета.\nB. Сравнить движение игрушечной машинки.\nC. Проверить 3 предмета большим магнитом с родителем.\nD. Сделать таблицу погоды.\n\nВ отчёте должны быть 6 разделов:\n1. Мой вопрос.\n2. Моё предсказание.\n3. Что я сделала.\n4. Мои данные.\n5. Мой вывод.\n6. Правило безопасности.\n\nПиши по-русски коротко. Можно рисовать.',
      ruPrimaryText: 'Сделай мини-лабораторный отчёт из 6 разделов на основе одного опыта недели.',
      enHelpText: 'Create a mini lab report. Pick ONE experiment (A–D). Fill 6 sections: question, prediction, what you did, data, conclusion, safety rule.',
      hint: 'Можно писать коротко и рисовать. Главное — структура. / Short notes and drawings are OK. Structure matters.',
      answer: 'Open-ended project. Must include most sections and one safe conclusion.'
    },
    {
      id: 'spelling-review',
      type: 'text',
      title: 'Правописание недели / Week Spelling',
      prompt: 'Напиши 6 слов на выбор:\nдлина\nмасса\nвывод\nстарт\nфиниш\nмагнит\nопыт\nданные\nпогода\nграфик',
      ruPrimaryText: 'Напиши на выбор любые 6 слов недели.',
      enHelpText: 'Write any 6 of the listed Russian words. Parent checks gently.',
      answer: 'Любые 6 написанных слов. / Any 6 attempted words.'
    },
    {
      id: 'speech-lab-defense',
      type: 'text',
      title: 'Защита проекта / Project Defense',
      prompt:
        'Объясни родителю по-русски:\n1. Какой опыт ты выбрала?\n2. Какое было предсказание?\n3. Какие данные ты записала?\n4. Какой вывод ты сделала?\n5. Какое правило безопасности ты соблюдала?',
      ruPrimaryText: 'Защити проект — ответь родителю по-русски на 5 вопросов.',
      enHelpText: 'Defend the project — answer 5 questions in Russian: experiment, prediction, data, conclusion, safety rule.',
      answer: 'Acceptable: Anita explains her chosen experiment, prediction, data, conclusion and one safety rule.'
    }
  ],
  notebookInstructions: [
    'Если нет принтера:',
    '1. Напиши название «Мини-лабораторный отчёт».',
    '2. Напиши 6 слов недели.',
    '3. Прочитай 5 фраз учёного.',
    '4. Реши 5 math-задач.',
    '5. Выбери один опыт недели.',
    '6. Заполни 6 разделов отчёта.',
    '7. Нарисуй данные или график.',
    '8. Объясни проект родителю.'
  ],
  printWorksheet: {
    title: 'Проект недели: мини-лабораторный отчёт / Week Project: Mini Lab Report',
    subtitle: 'Неделя 3 · День 5 / Week 3 · Day 5',
    pages: [
      {
        title: 'Мини-лабораторный отчёт / Mini Lab Report',
        blocks: [
          { type: 'text', text: 'Имя: ______________  Дата: ______________ / Name: __________  Date: __________' },
          { type: 'text', text: 'Слова недели / Week words:' },
          { type: 'list', items: [
            'измерить / measure',
            'длина / length',
            'движение / motion',
            'расстояние / distance',
            'сила / force',
            'магнит / magnet',
            'данные / data',
            'таблица / table',
            'график / graph',
            'вывод / conclusion',
            'опыт / experiment',
            'безопасность / safety'
          ] },
          { type: 'text', text: 'Фразы учёного — прочитай и поставь галочку: / Scientist phrases — read and tick:' },
          { type: 'list', items: [
            '☐ Я задаю вопрос.',
            '☐ Я делаю предсказание.',
            '☐ Я провожу безопасный опыт.',
            '☐ Я записываю данные.',
            '☐ Я делаю вывод.'
          ] },
          { type: 'text', text: 'Выбери опыт / Pick one experiment:' },
          { type: 'list', items: [
            '☐ A. Измерить 2 предмета.',
            '☐ B. Сравнить движение игрушечной машинки.',
            '☐ C. Проверить 3 предмета большим магнитом с родителем.',
            '☐ D. Сделать таблицу погоды.'
          ] }
        ]
      },
      {
        title: 'Проверка и безопасность / Review and Safety',
        blocks: [
          { type: 'text', text: 'Математическая проверка / Math review:' },
          { type: 'list', items: [
            '1. Книга 22 см, карандаш 14 см. На сколько книга длиннее? ______',
            '2. Машинка проехала 18 см, потом 25 см. Сколько всего? ______',
            '3. Магнит притянул 4 предмета, не притянул 6. Сколько всего? ______',
            '4. Солнечно 3 дня, облачно 2, дождь 1. Сколько всего дней? ______',
            '5. В отчёте 6 разделов. Сделала 4. Осталось ______.'
          ] },
          { type: 'text', text: 'Безопасно или нет? Напиши Б = безопасно с родителем, Н = нельзя. / Safe or not? Write Б or Н.' },
          { type: 'list', items: [
            '1. Измерить карандаш линейкой. ____',
            '2. Сравнить книгу и ложку. ____',
            '3. Мягко толкнуть игрушечную машинку. ____',
            '4. Бросить машинку со стола. ____',
            '5. Использовать большой магнит с родителем. ____',
            '6. Взять маленький магнит в рот. ____',
            '7. Смотреть погоду из окна. ____',
            '8. Выходить одной наблюдать грозу. ____',
            '9. Записать данные в таблицу. ____',
            '10. Делать опыт с розеткой. ____',
            '11. Нарисовать график. ____',
            '12. Использовать стеклянную банку без родителя. ____'
          ] },
          { type: 'text', text: 'Правописание / Spelling — напиши любые 6 слов недели:' },
          { type: 'list', items: [
            '______   ______   ______',
            '______   ______   ______'
          ] }
        ]
      },
      {
        title: 'Мой отчёт и защита / My Report and Defense',
        blocks: [
          { type: 'text', text: 'Отчёт — 6 разделов / Report — 6 sections:' },
          { type: 'list', items: [
            '1. Мой вопрос: ____________________',
            '2. Моё предсказание: ____________________',
            '3. Что я сделала: ____________________',
            '4. Мои данные: ____________________',
            '5. Мой вывод: ____________________',
            '6. Правило безопасности: ____________________'
          ] },
          { type: 'text', text: 'Рисунок или график / Drawing or graph:' },
          { type: 'text', text: '┌──────────────────────────────────────┐  │                                      │  │                                      │  │                                      │  └──────────────────────────────────────┘' },
          { type: 'text', text: 'Защита проекта / Project defense:' },
          { type: 'list', items: [
            '☐ Я сказала, какой опыт выбрала.',
            '☐ Я сказала предсказание.',
            '☐ Я сказала данные.',
            '☐ Я сказала вывод.',
            '☐ Я сказала правило безопасности.'
          ] },
          { type: 'text', text: 'Parent rubric: чтение русского (15) · устное объяснение (15) · математика (15) · научный процесс (20) · правило безопасности (10) · полнота проекта (15) · аккуратность (5) · усилие (5).' },
          { type: 'text', text: 'Parent Check:' },
          { type: 'list', items: [
            '☐ Прочитала слова недели.',
            '☐ Прочитала фразы учёного.',
            '☐ Решила math review.',
            '☐ Проверила безопасность.',
            '☐ Сделала мини-отчёт.',
            '☐ Объяснила проект родителю.'
          ] },
          { type: 'text', text: 'Notebook Mode fallback — если нет принтера, сделай эти задания в тетради.' }
        ]
      }
    ]
  },
  parentGuide: {
    goal: 'Анита собирает Week 3 в проект «Мини-лабораторный отчёт» и объясняет его родителю.',
    mathGoal: 'Смешанное повторение: вычитание, сложение, сравнение, таблица, «сколько осталось».',
    russianGoal: 'Прочитать слова недели и 5 фраз учёного.',
    readingWritingGoal: 'Прочитать фразы, написать 6 слов, заполнить короткий отчёт.',
    practicalGoal: 'Создать мини-лабораторный отчёт с вопросом, предсказанием, данными, выводом и правилом безопасности.',
    parentTheoryCard: {
      title: 'Как провести мини-лабораторный отчёт',
      purpose: 'Помочь родителю превратить опыт в понятный научный проект без давления и перфекционизма.',
      keyMessage: 'Хороший маленький учёный задаёт вопрос, делает предсказание, проверяет безопасно, записывает данные и делает вывод.',
      parentScript: [
        '«Сегодня ты не просто решаешь задания. Ты собираешь отчёт учёного.»',
        '«Предсказание — это что ты думаешь до опыта.»',
        '«Данные — это что ты записала.»',
        '«Вывод — это что ты поняла.»',
        '«Безопасность важнее красивого опыта.»'
      ],
      practiceSteps: [
        'Пусть Анита выберет один опыт недели.',
        'Помогите сформулировать простой вопрос.',
        'Спросите предсказание.',
        'Посмотрите данные.',
        'Помогите сказать один короткий вывод.',
        'Попросите назвать одно правило безопасности.'
      ],
      doNotSay: [
        '«Это неправильно, переделай всё.»',
        'Не требовать длинный отчёт.',
        'Не сравнивать с Максимом.',
        'Не делать опыт за ребёнка.'
      ],
      paperOnlyNotes: [
        'Можно выполнять полностью в тетради.',
        'Рисунок или график может быть простым.',
        'Главное — структура: вопрос, предсказание, данные, вывод, безопасность.'
      ]
    },
    whatThisLessonTeaches: 'Анита учится собирать наблюдение в научную структуру.',
    keyMessage: 'Я могу думать как учёный: вопрос → предсказание → опыт → данные → вывод.',
    howToExplain: 'Скажите: «Учёный не просто делает опыт. Учёный объясняет, что хотел узнать, что предполагал, что увидел и что понял.»',
    exampleDialogue:
      'Parent: Какой опыт ты выбрала?\nChild: Магнит.\nParent: Что ты предсказала?\nChild: Скрепка притянется.\nParent: Что показали данные?\nChild: Скрепка притянулась, карандаш нет.\nParent: Какой вывод?\nChild: Магнит притягивает скрепку, но не карандаш.',
    readingSupport: 'Слова «предсказание», «лабораторный», «безопасность» можно читать по частям.',
    russianSpeechGoal: 'Анита объясняет минимум 3 части проекта по-русски: опыт, данные, вывод.',
    mathAnswerKey:
      'math-week3-review: 1) 8 см. 2) 43 см. 3) 10. 4) 6. 5) 2.\nlab-safety-sort: safe 1,2,3,5,7,9,11; not allowed 4,6,8,10,12.',
    spellingAnswerKey: 'длина\nмасса\nвывод\nстарт\nфиниш\nмагнит\nопыт\nданные\nпогода\nграфик',
    answerKey: [
      { taskId: 'reading-review-words', answer: 'Попытка чтения 12 слов недели.' },
      { taskId: 'oral-defense-reading', answer: 'Попытка чтения и/или устного произнесения 5 фраз.' },
      { taskId: 'math-week3-review', answer: '8; 43; 10; 6; 2.' },
      { taskId: 'lab-safety-sort', answer: 'Safe: 1,2,3,5,7,9,11. Not allowed: 4,6,8,10,12.' },
      { taskId: 'project-mini-lab-report', answer: 'Отчёт содержит большинство разделов и один безопасный вывод.' },
      { taskId: 'spelling-review', answer: 'Любые 6 написанных слов.' },
      { taskId: 'speech-lab-defense', answer: 'Осмысленное объяснение проекта по-русски.' }
    ],
    check: [
      'Анита прочитала слова недели.',
      'Анита прочитала или сказала фразы учёного.',
      'Анита решила math review.',
      'Анита проверила безопасность.',
      'Анита сделала мини-отчёт.',
      'Анита объяснила проект родителю.'
    ],
    spellingCheck: 'Проверить 6 выбранных слов. Исправлять мягко.',
    readingCheck: 'Главное — попытка русского чтения и понимание смысла.',
    practicalCheck: 'Отчёт должен иметь вопрос, предсказание, действие, данные, вывод и безопасность.',
    projectCriteria: 'Project should include: 1) Question. 2) Prediction. 3) What Anita did. 4) Data. 5) Conclusion. 6) Safety rule. 7) Drawing/table/graph.',
    rubric:
      'Russian reading attempt — 15 points\nRussian oral explanation — 15 points\nMath review correctness — 15 points\nScience process understanding — 20 points\nSafety rule — 10 points\nProject completeness — 15 points\nCreativity/neatness — 5 points\nEffort and focus — 5 points',
    commonMistakes: [
      '«Отчёт — это длинный текст.» Правильно: «Отчёт может быть коротким, если есть структура.»',
      '«Если предсказание не совпало, это плохо.» Правильно: «Это нормально. Опыт помогает узнать.»',
      '«Красивый рисунок важнее вывода.» Правильно: «Главное — данные и вывод.»',
      '«Безопасность можно пропустить.» Правильно: «Безопасность — часть науки.»'
    ],
    discussionPrompts: [
      'Какой опыт тебе понравился больше всего?',
      'Что такое предсказание?',
      'Что такое данные?',
      'Какой вывод ты сделала?',
      'Какое правило безопасности самое важное?'
    ],
    ifEasy: 'Попросить Аниту провести 2-минутную презентацию отчёта по-русски.',
    ifDifficult: 'Пусть Анита выберет только 3 части: что сделала, данные, вывод.',
    rewardGuidance: 'Проектный день: базовая награда 5 нимов. Бонусы за чтение, объяснение и аккуратный проект.',
    tokenReward: 'Нимы — это призовые токены курса, а не оплата.',
    parentOnlyNotes: 'Не стремиться к идеальному научному отчёту. Цель — структура мышления: вопрос, предсказание, данные, вывод.',
    safetyNotes: 'Не проводить новые опасные опыты. Использовать только безопасные варианты недели: измерение предметов, мягкое движение игрушки, большой магнит с родителем, наблюдение погоды из окна.'
  },
  reward: {
    unit: 'nim',
    unitName: 'ним',
    base: 5,
    max: 8,
    label: 'Награда за проект',
    display: '5 нимов',
    bonuses: [
      { id: 'russian-reading-attempt', label: 'Бонус за хорошую попытку русского чтения', amount: 1 },
      { id: 'clear-explanation', label: 'Бонус за ясное объяснение родителю', amount: 1 },
      { id: 'neat-mini-report', label: 'Бонус за аккуратный мини-отчёт', amount: 1 }
    ]
  },
  completionRequirements: {
    requiredTaskIds: [
      'reading-review-words',
      'oral-defense-reading',
      'math-week3-review',
      'lab-safety-sort',
      'project-mini-lab-report',
      'spelling-review',
      'speech-lab-defense'
    ],
    allowNotebookCompletion: true
  },
  nextLessonId: 'anita-week-4-day-1'
};

export default day5;
